<div class="row width-limit" *ngIf="bannerTypes?.length">
	<div class="col">
		<div id="bannerCarousel" class="carousel slide carousel-fade">
			<div class="carousel-inner px-3">
				<div *ngFor="let bannerType of bannerTypes; let i = index" class="carousel-item active">
					<div class="row" *ngIf="activeIndex === i" [@activeInactiveFade]>
						<div class="col" [class]="bannerType.largeBannerClassName">
							<div class="row d-flex align-items-center h-100">
								<div class="col-12 col-md-8">
									<p class="banner-header" [innerHtml]="bannerType.bannerHeaderHtml"></p>
									<p class="mb-0">
										<a href="javascript:void(0)" role="button" class="btn btn-secondary" (click)="bannerType.onActionClicked()">Learn More</a>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
